export default "__VITE_ASSET__CtpOvO6b__"